var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 20,
    viewBox: "0 0 13 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8696 0H1.52176C0.682616 0 0 0.682616 0 1.52175V18.4782C0 19.3172 0.682616 20 1.52176 20H10.8696C11.7085 20 12.3913 19.3172 12.3913 18.4782V1.52175C12.3913 0.682616 11.7085 0 10.8696 0ZM11.0869 18.4782C11.0869 18.596 10.9874 18.6956 10.8696 18.6956H1.52176C1.40394 18.6956 1.30437 18.596 1.30437 18.4782V1.52175C1.30437 1.40394 1.40394 1.30437 1.52176 1.30437H10.8696C10.9874 1.30437 11.0869 1.40394 11.0869 1.52175V18.4782Z",
    fill: "#023047",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5219 3.04346H0.652344V4.34779H11.5219V3.04346Z",
    fill: "#023047",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5219 13.9131H0.652344V15.2174H11.5219V13.9131Z",
    fill: "#023047",
    fillOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.08855 15.5649C5.32137 15.5649 4.69727 16.1891 4.69727 16.9562C4.69727 17.7234 5.3214 18.3475 6.08855 18.3475C6.8557 18.3475 7.47984 17.7234 7.47984 16.9562C7.47984 16.1891 6.85574 15.5649 6.08855 15.5649ZM6.08855 17.0432C6.0405 17.0432 6.0016 17.004 6.0016 16.9562C6.0016 16.9084 6.0405 16.8693 6.08855 16.8693C6.1366 16.8693 6.1755 16.9084 6.1755 16.9562C6.1755 17.004 6.1366 17.0432 6.08855 17.0432Z",
    fill: "#023047",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone_icon.23c3cf6ff3bb178c8562080ff2346f84.svg";
export { ForwardRef as ReactComponent };